//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { ref, computed, reactive } from "@nuxtjs/composition-api";
import SfButton from "~/themes/fiskarsMoominDefault/components/components/atoms/SfButton/SfButton.vue";
import SfInput from "~/themes/fiskarsMoominDefault/components/components/atoms/SfInput/SfInput.vue";
import SfLoader from "~/themes/fiskarsMoominDefault/components/components/atoms/SfLoader/SfLoader.vue";
import { validateEmail, markFieldAsTouched, isFormValidated, touchedState } from "~/helpers/validation-utils";
import { useUiNotification, useSalesCrm, useUserAccount } from '~/composables';
import { CMSNotificationType, extractCMSNotificationMessage } from "~/helpers/extractCMSNotificationMessage";

export default {
  name: "ForgotPassowordForm",
  components: {
    SfInput,
    SfButton,
    SfLoader,
},
  props: {
    formLabel: {
      type: String,
    },
    emailLabel: {
      type: String,
    },
    emailPlaceholder: {
      type: String,
    },
    emailErrorMessage: {
      type: String,
    },
    emailFormatErrorMessage: {
      type: String,
    },
    successMessageTitle: {
      type: String,
    },
    successMessageDescription: {
      type: Object
    },
    formValidationMessage: {
      type: String,
    },
    submitButton: {
      type: String,
    },
    environmentPrefixUrlCrm: {
      type: String,
    },
    success: {
      type: Object
    },
    error: {
      type: Object
    }
  },
  setup(props) {
    const email = ref("");
    const password = ref("");
    const loading = ref(false);
    const formSubmitted = ref(false);
    const { send: sendNotification } = useUiNotification();
    const { initForgotPassword } = useSalesCrm(`loadcrm`);
    const { verifyCaptcha, destroyCaptcha, recaptchaFlag } = useUserAccount();


    const submit = async () => {
      try {
        loading.value = true;
        const ctToken =  await verifyCaptcha();
        const response = await initForgotPassword({ email: email.value, url: props.environmentPrefixUrlCrm, captchaToken: ctToken });
        if(response.errorMessage) {
          sendNotification({
          type: CMSNotificationType.ERROR,
          message: extractCMSNotificationMessage(props.error, CMSNotificationType.ERROR, response?.errorCode) || response.errorMessage || props.formValidationMessage
          });
        } else {
          formSubmitted.value = true;
        }
      } catch (error) {
        sendNotification({
          type: CMSNotificationType.ERROR,
          message: extractCMSNotificationMessage(props.error, CMSNotificationType.ERROR) || props.formValidationMessage
        });
      } finally {
        destroyCaptcha();
      }
      loading.value = false;
    };

    //can submit form
    const canSubmit = computed(() => !!isFormValidated(formValues));

    const formValues = reactive({
      email: {
        label: props.emailLabel,
        placeholder: props.emailPlaceholder,
        touched: touchedState(email.value),
        value: () => email.value,
        validation: computed(() => {
          if (!formValues.email.touched) return { valid: true, error: "" };
          const result = validateEmail(email.value, props.emailLabel);
          return {
            valid: result.isValid,
            error: result.isValid ? "" : result.errorMessage || props.emailErrorMessage,
          };
        })
      },
    });

    return {
      email,
      password,
      submit,
      canSubmit,
      formValues,
      markFieldAsTouched,
      loading,
      formSubmitted,
      recaptchaFlag
    };
  },
};
